import React from 'react';
import './HeadToHeadTab.scss';
import DynamicIframe from '../Common/DynamicIframe';

const HeadToHeadTab = ({ matchDetails }) => {
  const statsV2BaseUrl =
    process.env.REACT_APP_API_PATH === 'https://dev.api.sketchbball.com'
      ? 'https://dev.stats.sketchbball.com/v2/embed/matches'
      : 'https://stats.sketchbball.com/v2/embed/matches';

  const match_id = matchDetails?.match_id;

  // Don't render if match_id is missing
  if (!match_id) {
    return null;
  }

  const headToHead_query_params =
    'lang=en_US&isDebug=false&showMatchFlow=false&showShotFrequency=false&showScoreBoard=false&showTeamStat=false&showHeadToHead=true&showBoxScore=false&showPlayByPlay=false&showTitle=true&isFixed=true&background=f6f6f6&maxWidth=100%&frequencyMode=all';
  const headToHead_url = `${statsV2BaseUrl}/${match_id}?${headToHead_query_params}`;

  return (
    <div className='head-to-head-tab'>
      <div className='head-to-head-container'>
        <DynamicIframe url={headToHead_url} className='head-to-head-iframe' />
      </div>
    </div>
  );
};

export default HeadToHeadTab;
